/* eslint react-hooks/exhaustive-deps: off */

import * as React from 'react';

export const useEffectChange = (callback: () => any, deps: any[]) => {
  React.useEffect(() => {
    callback();
  }, deps)
}